// extracted by mini-css-extract-plugin
export var card = "_va-0";
export var details = "_va-1";